import qs from 'qs'
import { NavigateOptions, useNavigate } from 'react-router-dom'

export const useCustomNavigate = () => {
  const navigate = useNavigate()

  /**
   * 自定义路由导航
   * @param path 路径
   * @param del 要删除的参数 string[] | string
   * @param options navigate原生配置对象
   * @returns
   */
  const customNavigator = async (
    path: string,
    del: string[] | string = '',
    options: NavigateOptions = {}
  ) => {
    const channelSearch = sessionStorage.getItem('channelSearch') || ''
    const [basePath, baseSearch] = path.split('?')

    const baseParams = qs.parse(baseSearch)
    const channelParams = qs.parse(
      channelSearch.startsWith('?') ? channelSearch.slice(1) : channelSearch
    )

    let paramsString = qs.stringify({
      ...channelParams,
      ...baseParams
    })

    paramsString = handleDelSearch(del, paramsString)

    const completePath = paramsString ? `${basePath}?${paramsString}` : basePath

    return navigate(completePath, options)
  }

  const handleDelSearch = (del: string[] | string, paramsString: string) => {
    if (!del) {
      return paramsString
    }

    const params = qs.parse(paramsString)
    if (Array.isArray(del)) {
      del.forEach((item) => {
        delete params[item]
      })
    }
    // 非数组
    if (del !== '') {
      delete params[del as string]
    }
    const sessionParams = qs.stringify(params)
    sessionStorage.setItem(
      'channelSearch',
      sessionParams === '' ? '' : `?${sessionParams}`
    )
    return qs.stringify(params)
  }

  return { customNavigator }
}
